import styled, { css } from 'styled-components';

const mobileContainer = css`
    display: flex !important;
    flex-direction: column;
    align-items: center;
    padding-top: 35px;
`;

// border: solid 0.6px #979797;
// border-width: 1px 0px 1px 0px;

export const Container = styled.div`
    flex: 1;
    display: flex;
    ${props => props.isMobile ? mobileContainer : `
        flex-direction: row !important;
        padding-left: 49px;
    `}
`;

export const Step = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #a7a7a7;
    padding-right: 9px;
    ${props => props.current && `
        font-weight: bold;
        color: #000000;
    `}
    ${props => props.isMobile && `
        margin-bottom: 35px;
    `}
`;